var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(-0.393 -0.067)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 52,
    height: 54,
    rx: 5,
    transform: "translate(0.393 0.067)",
    fill: "#3b5998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "facebook",
    d: "M18.7,5.084h2.8V.216A36.092,36.092,0,0,0,17.424,0c-4.03,0-6.79,2.535-6.79,7.194v4.288H6.187v5.442h4.447V30.616h5.452V16.924h4.267l.677-5.442H16.085V7.733c0-1.573.425-2.65,2.616-2.65Z",
    transform: "translate(12.534 9.221)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.5a7140e6f0d4d1993f624823e66bab47.svg";
export { ForwardRef as ReactComponent };